import type { ModalProps } from '@viewup/ui';
import { AlertModal, Column, InfoCircleFillWarning, Typography } from '@viewup/ui';
import type { isSuspendedResult } from 'app/viewing/_entities/post';
import { postCampaignStatusLabel } from 'app/viewing/_entities/post';
import dayjs from 'dayjs';
import type { ReactNode } from 'react';

type SuspensionAlertModalProps = Pick<ModalProps, 'isOpen' | 'exitHandler'> & isSuspendedResult;
export const SuspensionAlertModal = (props: SuspensionAlertModalProps) => {
  const { accountName, penaltyCountMap, suspensionEndDate, isOpen, exitHandler } = props;

  return (
    <AlertModal
      content={`활동제한 패널티 주의 3회로 인해\n포스팅 뷰업 활동이 중지 되었어요.\n신청했던 캠페인들도 모두 미제출 차감돼요.`}
      exitHandler={exitHandler}
      grayText={[
        {
          left: <Label>블로그 ID</Label>,
          right: <Content>{accountName}</Content>,
        },
        {
          left: <Label>작용 사유</Label>,
          right: (
            <Column>
              {Object.entries(penaltyCountMap).map(([key, value]) =>
                value === 0 ? null : (
                  <Content key={key}>{`${postCampaignStatusLabel[key]} ${value}건`}</Content>
                ),
              )}
            </Column>
          ),
          wrapperStyle: { alignItems: 'flex-start' },
        },
        {
          left: <Label>적용 기간</Label>,
          right: (
            <Content>
              <Typography color='text.danger' fontType='body2.regular'>
                {dayjs(suspensionEndDate).format('YY.MM.DD')}
              </Typography>
              까지
            </Content>
          ),
        },
      ]}
      hasCloseButton={false}
      hasIcon
      iconSource={InfoCircleFillWarning}
      isOpen={isOpen}
      onClickButton={() => props.exitHandler()}
      styledComponents={{
        content: {
          css: {
            '& :last-child': {
              gap: '8px',
            },
          },
          gap: 20,
        },
        title: {
          mb: 16,
        },
      }}
      title='활동제한 안내'
    />
  );
};

const Label = (props: { children: ReactNode }) => {
  return (
    <Typography color='text.tertiary' fontType='body2.regular'>
      {props.children}
    </Typography>
  );
};

const Content = (props: { children: ReactNode }) => {
  return (
    <Typography color='text.primary' fontType='body2.regular'>
      {props.children}
    </Typography>
  );
};
